/* Light Wear Store - Homepage JS */

// ---- Hero Slider ----
(function () {
  const track = document.getElementById('lws-hero-track');
  const dots = document.querySelectorAll('#lws-hero-dots .lws-hero__dot');
  if (!track) return;

  let current = 0;
  const total = track.children.length;

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }

  document.getElementById('lws-hero-prev')?.addEventListener('click', () => goTo(current - 1));
  document.getElementById('lws-hero-next')?.addEventListener('click', () => goTo(current + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

  let timer = setInterval(() => goTo(current + 1), 5000);
  track.closest('.lws-hero')?.addEventListener('mouseenter', () => clearInterval(timer));
  track.closest('.lws-hero')?.addEventListener('mouseleave', () => { timer = setInterval(() => goTo(current + 1), 5000); });
})();

// ---- Product Sliders (arrows + swipe) ----
(function () {
  const sliders = {
    'new-in': { track: document.getElementById('lws-track-new-in'), pos: 0 },
    'sale':   { track: document.getElementById('lws-track-sale'),   pos: 0 },
    'suits':  { track: document.getElementById('lws-track-suits'),  pos: 0 },
    'maxis':  { track: document.getElementById('lws-track-maxis'),  pos: 0 },
    'dresses':{ track: document.getElementById('lws-track-dresses'),pos: 0 },
  };

  function getCardWidth(track) {
    const card = track?.querySelector('.lws-product-card');
    if (!card) return 0;
    return card.offsetWidth + 16;
  }

  function getVisibleCount(track) {
    if (!track) return 2;
    const container = track.closest('.lws-slider-track-outer');
    return Math.round(container.offsetWidth / getCardWidth(track));
  }

  function slide(key, dir) {
    const state = sliders[key];
    if (!state || !state.track) return;
    const cardW = getCardWidth(state.track);
    const visible = getVisibleCount(state.track);
    const totalCards = state.track.children.length;
    const maxPos = Math.max(0, (totalCards - visible) * cardW);
    if (dir === 1) {
      state.pos = Math.min(state.pos + cardW, maxPos);
    } else {
      state.pos = Math.max(state.pos - cardW, 0);
    }
    state.track.style.transform = 'translateX(-' + state.pos + 'px)';
  }

  // Arrow buttons
  document.querySelectorAll('.lws-slider-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.slider;
      const dir = btn.classList.contains('lws-slider-btn--next') ? 1 : -1;
      slide(key, dir);
    });
  });

  // Touch swipe for every slider track
  Object.entries(sliders).forEach(([key, state]) => {
    const el = state.track;
    if (!el) return;
    let startX = 0, startY = 0, dragging = false;

    el.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });

    el.addEventListener('touchend', e => {
      if (!dragging) return;
      dragging = false;
      const dx = startX - e.changedTouches[0].clientX;
      const dy = Math.abs(startY - e.changedTouches[0].clientY);
      if (Math.abs(dx) < 30 || dy > Math.abs(dx)) return; // ignore small or vertical swipes
      slide(key, dx > 0 ? 1 : -1);
    }, { passive: true });
  });
})();

// ---- Wishlist toggle ----
document.querySelectorAll('.lws-product-card__wishlist').forEach(btn => {
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    const svg = this.querySelector('svg');
    const filled = this.dataset.filled === 'true';
    this.dataset.filled = filled ? 'false' : 'true';
    svg.style.fill = filled ? 'none' : '#e63946';
    svg.style.stroke = filled ? 'currentColor' : '#e63946';
  });
});